import { createTheme } from "@mantine/core"
import { araColors, mantineColorShades } from "./colors"

export const araTheme = createTheme({
	// Custom color schemes
	colors: mantineColorShades,

	// Primary color
	primaryColor: "araBlue",
	primaryShade: 5,

	// Component overrides
	components: {
		Input: {
			defaultProps: {
				variant: "default",
			},
		},
	},

	// Typography
	fontFamily: 'Inter, "Noto Color Emoji", sans-serif',
	fontFamilyMonospace: "JetBrains Mono, monospace",
	headings: {
		fontWeight: "500",
		sizes: {
			h1: { fontSize: "32px", lineHeight: "1.2" },
			h2: { fontSize: "24px", lineHeight: "1.3" },
			h3: { fontSize: "20px", lineHeight: "1.4" },
			h4: { fontSize: "18px", lineHeight: "1.4" },
			h5: { fontSize: "16px", lineHeight: "1.5" },
			h6: { fontSize: "14px", lineHeight: "1.5" },
		},
	},

	// Font sizes
	fontSizes: {
		xs: "12px",
		sm: "14px",
		md: "16px",
		lg: "18px",
		xl: "20px",
		xxl: "36px",
	},

	// Spacing
	spacing: {
		xs: "4px",
		sm: "8px", // Matches Figma 8px spacing
		md: "16px",
		lg: "24px",
		xl: "32px", // Matches Figma 32px padding
	},

	// Border radius
	radius: {
		xs: "2px",
		sm: "4px",
		md: "8px",
		lg: "12px", // Matches Figma rounded-xl
		xl: "16px",
	},

	// Shadows
	shadows: {
		xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
		sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
		md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
		lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 35px -7px, rgba(0, 0, 0, 0.04) 0px 14px 14px -7px",
		xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 45px -9px, rgba(0, 0, 0, 0.04) 0px 18px 18px -9px",
	},

	breakpoints: {
		sm: "36em", // 576px (matches Bootstrap sm)
		md: "48em", // 768px (matches Bootstrap md)
		lg: "62em", // 992px (matches Bootstrap lg)
		xl: "75em", // 1200px (matches Bootstrap xl)
		xxl: "87.5em", // 1400px (matches Bootstrap xxl)
	},

	// Other theme overrides
	other: {
		// Custom properties that can be accessed via theme.other
		colors: araColors,

		// Keep systematic design system variables
		opacity: {
			hover: "0.7",
		},
		transitions: {
			fast: "0.2s ease",
		},
	},
})

export type AraTheme = typeof araTheme
